import { EditorPlugin } from "@draft-js-plugins/editor";
import { ContentBlock, ContentState } from "draft-js";
import React from "react";

interface LinkComponentProps {
  contentState: ContentState;
  entityKey: string;
  children: React.ReactNode;
}

// Component to render LINK entities (uppercase - from htmlToDraft)
const LinkComponent = (props: LinkComponentProps) => {
  const { contentState, entityKey, children } = props;
  const entity = contentState.getEntity(entityKey);
  const data = entity.getData();
  const url = data.url || data.href;

  // Validate URL exists
  if (!url || typeof url !== "string") {
    console.warn("Link entity missing URL:", data);
    return React.createElement(
      "span",
      { className: "text-box__broken-link" },
      children,
    );
  }

  const goToUrl = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open(url, "_blank", "noreferrer, noopener");
  };

  return React.createElement(
    "a",
    {
      href: url,
      className: "text-box__hyperlink",
      rel: "noopener",
      target: "_blank",
      onClick: goToUrl,
    },
    children,
  );
};

// Strategy to find LINK entities (uppercase only - linkifyPlugin handles lowercase "link")
const findLinkEntities = (
  contentBlock: ContentBlock,
  callback: (start: number, end: number) => void,
  contentState: ContentState,
) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    if (entityKey !== null) {
      const entity = contentState.getEntity(entityKey);
      // Only handle "LINK" (uppercase) - linkifyPlugin handles "link" (lowercase)
      return entity.getType() === "LINK";
    }
    return false;
  }, callback);
};

// Create a plugin for LINK entities
export default function createLinkPlugin(): EditorPlugin {
  return {
    decorators: [
      {
        strategy: findLinkEntities,
        component: LinkComponent,
      },
    ],
  };
}
